import React, { useEffect, useState } from 'react';
import { useToastrVanila } from '../../hooks/util/useToastrVanila';
import IFormError from '../../interfaces/IFormError';
import debounce from 'lodash.debounce';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import ITypeDocument from '../../interfaces/ITypeDocument';
import { useTypeDocumentService } from '../../hooks/services/useTypeDocumentService';

interface IProps {
  setDocumentType: (documentType: ITypeDocument | null) => void;
  documentType: ITypeDocument | null;
}

const SearchDocumentType = (props: IProps) => {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState<readonly ITypeDocument[]>([]);
  const loadingInput = open;

  const request = useTypeDocumentService();

  const toastr = useToastrVanila();

  const [errors, setErrors] = useState<IFormError | null>();

  useEffect(() => {
    let active = true;

    if (!loadingInput) {
      return undefined;
    }

    (async () => {
      if (active) {
        await loadDocumentType(' - ');
      }
    })();

    return () => {
      active = false;
    };
  }, [loadingInput]);

  useEffect(() => {
    setErrors(null);
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  const loadDocumentType = debounce(async (filter = ' ') => {
    setLoading(true);
    await request
      .search(filter)
      .then(documentType => {
        setOptions(documentType);
        setLoading(false);
      })
      .catch(error => {
        toastr.error(`Erro ao carregar os dados: ${error.message}`);
        setLoading(false);
      });
  }, 500);

  return (
    <Autocomplete
      open={open}
      value={props.documentType}
      onChange={(e: any, newValue) => {
        const castedLocal = { ...newValue } as ITypeDocument;
        props.setDocumentType({ ...castedLocal });
      }}
      onOpen={() => {
        setOpen(true);
        props.setDocumentType(null);
      }}
      onClose={() => {
        setOpen(false);
      }}
      isOptionEqualToValue={(option, value) => {
        return option?.description === value?.description;
      }}
      getOptionLabel={option => (option?.id && option.id ? `${option.id} - ${option.description}` : '')}
      options={options}
      loading={loading}
      renderInput={params => (
        <TextField
          {...params}
          label="Pesquisar tipo de documento por nome"
          error={Boolean(errors?.code)}
          helperText={errors?.code}
          size="small"
          onChange={e => {
            loadDocumentType(e.target.value);
          }}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
};

export default SearchDocumentType;
